var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
var Container = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  height: 104px;\n  margin-top: 10px;\n  width: 100%;\n  border: solid 1px white;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  padding-left: 10px;\n  padding-top: 5px;\n"], ["\n  height: 104px;\n  margin-top: 10px;\n  width: 100%;\n  border: solid 1px white;\n  display: grid;\n  grid-template-columns: 50% 50%;\n  padding-left: 10px;\n  padding-top: 5px;\n"])));
var InnerContainer = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  grid-template-columns: 40% auto;\n  display: grid;\n"], ["\n  grid-template-columns: 40% auto;\n  display: grid;\n"])));
var LabelField = styled.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  color: white;\n  text-transform: uppercase;\n"], ["\n  color: white;\n  text-transform: uppercase;\n"])));
var ValueField = styled.div(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  color: white;\n  text-transform: uppercase;\n"], ["\n  color: white;\n  text-transform: uppercase;\n"])));
var Value = styled.span(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  margin-left: 10px;\n"], ["\n  margin-left: 10px;\n"])));
export default function TPGeneralInformationArea(_a) {
    var content = _a.content;
    var _b = content.residentRoles, residentRoles = _b === void 0 ? [] : _b, activeVabArray = content.activeVabArray, modeSystem = content.modeSystem, modeConsole = content.modeConsole, activeRoleLongText = content.activeRoleLongText;
    var _c = useState(moment()), currDate = _c[0], setCurrDate = _c[1];
    useEffect(function () {
        setInterval(function () {
            setCurrDate(moment.utc());
        }, 1000);
    }, []);
    return (React.createElement(Container, { "data-area": "general-information-area" },
        React.createElement(InnerContainer, null,
            React.createElement(LabelField, null, "Active Role"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    activeRoleLongText,
                    " ")),
            React.createElement(LabelField, null, "Roles Signed On"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    residentRoles.join(','))),
            React.createElement(LabelField, null, "Array"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    activeVabArray,
                    " "))),
        React.createElement(InnerContainer, null,
            React.createElement(LabelField, null, "Mode System"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    modeSystem)),
            React.createElement(LabelField, null, "Mode Console"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    modeConsole)),
            React.createElement(LabelField, null, "Date"),
            React.createElement(ValueField, null,
                ":",
                React.createElement(Value, null,
                    " ",
                    moment().format('DD/MM/YYYY'))),
            React.createElement(LabelField, null, "GMT"),
            React.createElement(ValueField, null,
                ": ",
                React.createElement(Value, null,
                    " ",
                    moment(currDate).format('HH:mm:ss'))))));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5;
//# sourceMappingURL=GeneralInformationArea.js.map